import { UpdateDealRequestContent, UpdateDealResponseContent } from "@equaliq/api-model";
import { createApiRequest } from "../common";

/**
 * API function to update a deal
 * @param request Deal update parameters
 * @returns Promise with updated deal and optional new version
 */
export const updateDealApi = async (request: UpdateDealRequestContent): Promise<UpdateDealResponseContent> => {
  const apiRequest = createApiRequest<UpdateDealResponseContent>('post', '/deals/update');
  return apiRequest(request);
};
